
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Hook to get the total count of content items for the current user
 */
export const useContentCount = () => {
  const { user } = useAuth();

  const { data: totalCount = 0, isLoading } = useQuery({
    queryKey: ["contentCount", user?.id],
    queryFn: async () => {
      if (!user) return 0;
      
      // Get count of all non-archived content items
      const { count, error } = await supabase
        .from("content_items")
        .select("*", { count: 'exact', head: true })
        .eq("user_id", user.id)
        .eq("archived", false);
      
      if (error) {
        console.error("Error fetching content count:", error);
        return 0;
      }
      
      return count || 0;
    },
    enabled: !!user,
  });

  return { totalCount, isLoading };
};
